import { useMemo } from "react";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { getBaseMarkdownComponents } from "../../utils/markdownComponents";

import type { MarkdownMessageProps } from "./types";

export const MarkdownMessage = ({
    content,
    components: customComponents,
    componentProps = {},
}: MarkdownMessageProps) => {
    const components = useMemo(
        () => (customComponents ? customComponents : getBaseMarkdownComponents(componentProps)),
        [componentProps, customComponents],
    );

    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={components}
        >
            {content}
        </ReactMarkdown>
    );
};
